import { FormControl } from '@mui/material';
import { Select } from 'shared-ui';
import styled from 'styled-components';

/** Same look as the refresh select of Zdarzenia → Bieżące (`app/events/Events.styles.tsx`). */
export const RefreshSelectFormControl = styled(FormControl)`
  min-width: 200px;
`;

export const RefreshSelect = styled(Select)`
  width: 200px;
  font-weight: 700;
  padding-top: 22px;
  padding-bottom: 5px;
`;
